import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface getNeedRepaymentPenaltyParamsType {
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  company_id: string;
}

export default ({
  resultKey = 'needRepaymentPenalty',
  successCallback,
  errorCallback,
  company_id,
}: getNeedRepaymentPenaltyParamsType) =>
  requestAsync({
    url: endpoints.getNeedRepaymentPenaltyUrl(company_id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getNeedRepaymentPenaltyUrl(company_id),
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
